module.exports = __webpack_public_path__ + "img/Yago.8545fb63.jpeg";